import { ROUTER_PATHS, useCheckPermissions, useLoaders } from '@/shared';
import { SaveNuevoTicket } from '../../shared/components/SaveNuevoTicket';
import { PermissionsEnum } from '@/auth/interfaces';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetContrato } from '@/shared/actions/erp';
import { toast } from 'react-toastify';

export interface CreateNuevoTicketPageInterface {}

const CreateNuevoTicketPage: React.FC<CreateNuevoTicketPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_ticket_soporte)
  const navigate = useNavigate()
  const {idcontrato} = useParams()
  if (!idcontrato) {
    navigate(ROUTER_PATHS.ticketSoporteCliente.nuevo_ticket_nav)
    toast.error('Debe seleccionar un registro para crear un ticket.')
    return null
  }
  const {
    data,
    isLoading,
  } = useGetContrato(idcontrato!, true)
  useLoaders(isLoading)
  if(!data && !isLoading){
    navigate(ROUTER_PATHS.ticketSoporteCliente.nuevo_ticket_nav)
    return 
  }
  return <SaveNuevoTicket titlePage="Crear Nuevo Ticket" contrato={data?.data} />;
};

export default CreateNuevoTicketPage;
